import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import {
  BUSINESS_ROLES_IDENTIFIER,
  ENTITLEMENTS_IDENTIFIER,
  LIST_IDENTIFIER,
  SHOW_TABLE_IDENTIFIER,
  STATE_IDENTIFIER,
} from "./constants";

const {
  ALL_USERS,
  LOADER_IDENTIFIER,
  RESPONSE_STATE,
  STEP_THREE_USERS_MANAGEMENT,
  PREV_ENTITLEMENTS,
  ENTITLEMENTS_BR_SELECTED,
  BUSINESS_ROLES,
  ENTITLEMENTS,
  TOTAL_ENTITLEMENTS,
  SELECTED_OFFICE,
  IS_SELF_SELECTED,
  ADDED_ENTITLEMENTS,
  ADDED_BR,
  DELETED_ENTITLEMENTS,
  DELETED_BR,
  MODIFIED_ENTITLEMENTS,
  EXISTING_SAME_DB,
  MODIFIED_BR,
  CALL_STATE,
  ERROR_MESSAGE,
  ABILITATION_DATE,
  SOD_CONFLICTS,
  COMMENT,
  PASSWORD_POLICY,
  IS_COMMENT_COMPULSORY,
  PAGINATED_BUSINESS_ROLES,
  PAGINATED_ENTITLEMENTS,
  ROLES,
  CONFIG_BUTTONS,
  CONFIGS,
} = STATE_IDENTIFIER;

export default {
  rawUsers: [],
  users: [],
  userOus: [],
  userManagers: [],
  usersLoader: false,
  selectedUserManagement: {},
  selectedOu: [],
  usersAccount: {
    list: [],
    loader: false,
  },
  userEntitlements: [],
  entitlementsOfBR: [],

  [ROLES]: [],
  [CONFIG_BUTTONS]: null,
  [CONFIGS]: null,
  [PASSWORD_POLICY]: {},
  [RESPONSE_STATE]: IResponseState.PENDING,
  [ERROR_MESSAGE]: "",
  [CALL_STATE]: IResponseState.PENDING,
  [LOADER_IDENTIFIER]: false,
  [ALL_USERS]: [],
  [SELECTED_OFFICE]: "",
  [IS_SELF_SELECTED]: false,
  [ADDED_ENTITLEMENTS]: [],
  [ADDED_BR]: [],
  [DELETED_ENTITLEMENTS]: [],
  [DELETED_BR]: [],
  [MODIFIED_ENTITLEMENTS]: [],
  [EXISTING_SAME_DB]: [],
  [MODIFIED_BR]: [],
  [SOD_CONFLICTS]: null,
  [COMMENT]: "",
  [IS_COMMENT_COMPULSORY]: true,
  [STEP_THREE_USERS_MANAGEMENT]: {
    [PREV_ENTITLEMENTS]: {
      [LIST_IDENTIFIER]: {
        [BUSINESS_ROLES_IDENTIFIER]: [],
        [ENTITLEMENTS_IDENTIFIER]: [],
      },
      [LOADER_IDENTIFIER]: false,
      [ENTITLEMENTS_BR_SELECTED]: {
        [LIST_IDENTIFIER]: [],
        [SHOW_TABLE_IDENTIFIER]: false,
      },
    },
    [ENTITLEMENTS]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
    [BUSINESS_ROLES]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
    [ABILITATION_DATE]: [],
    [TOTAL_ENTITLEMENTS]: {
      [BUSINESS_ROLES_IDENTIFIER]: [],
      [ENTITLEMENTS_IDENTIFIER]: [],
    },
    [PAGINATED_BUSINESS_ROLES]: {},
    [PAGINATED_ENTITLEMENTS]: {},
  },
};
